{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "ดูตัวเลือกทั้งหมด",
  "Spoiler_Reveal_Tooltip": "คลิกเพื่อเปิด",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet สิ่งนี้",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "รายการยุบแล้ว",
  "Spoiler_Reveal_Video_CTA": "แสดงวิดีโอ",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "ขยายรูปภาพ",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "ดูผลทั้งหมด",
  "Spoiler_Reveal_Image_Placeholder": "รูปภาพนี้มีการสปอยล์",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "แถบเลื่อนเพื่อค้นหา",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "คุณสามารถโหวตได้มากกว่า 1 คำตอบ",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "แสดงตัวควบคุมเสียงเพิ่มเติม",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "ปิด",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "กำลังโหลด {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "ใช้รูปประจำตัว",
  "Preview_ReadMore_Label": "อ่านเพิ่มเติม",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "ความดัง",
  "Spoiler_Reveal_Gallery_Placeholder": "แกลเลอรีนี้มีการสปอยล์",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "จองเลย",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "เปิดเสียง",
  "Spoiler_Reveal_Gallery_CTA": "แสดงแกลเลอรี",
  "Poll_Viewer_ShowLess_CTA": "แสดงลดลง",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "ปิดเสียง",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} ไม่ระบุชื่อ",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "ติดตาม",
  "VerticalEmbed_Products_Button": "ซื้อเลย",
  "Poll_Viewer_Toast_Error_ServerDown": "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ กรุณาลองอีกครั้งภายหลัง",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "คนโหวตให้คำตอบนี้ {{count}} คน",
  "Poll_Viewer_VoteCount": "โหวด {{number}} คน",
  "VerticalEmbed_Events_Button": "ลงทะเบียนตอนนี้",
  "Spoiler_Reveal_Image_CTA": "แสดงรูปภาพ",
  "Poll_Viewer_Toast_Error_Connection": "ไม่มีอินเตอร์เน็ตกรุณาตรวจสอบการเชื่อมต่อ",
  "Poll_Viewer_Visibility_Owner_Footer": "คุณเท่านั้นที่สามารถมองเห็นผลการโหวต",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "คนโหวตให้คำตอบนี้ {{count}} คน",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "รายการเผยแล้ว",
  "Audio_Plugin_Cover_Alt": "ภาพปกไฟล์เสียง",
  "Spoiler_Reveal_Video_Placeholder": "วิดีโอนี้มีการสปอยล์",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "ดูโพสต์ฉบับเต็ม",
  "UploadFile_Viewer_Download": "ดาวน์โหลด {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} ชม.",
  "VerticalEmbed_Units_Minute": "{{minutes}} นาที",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
